exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cxScrollable-container {\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./~/@c4/ui/src/app/directives/scrollable/scrollable.directive.less
// module id = 1481
// module chunks = 2